import {ChangeDetectionStrategy, Component, OnDestroy, OnInit, Signal} from '@angular/core';
import {LayoutService} from "./_metronic/layout";

import {DefaultLayoutConfig, ILayout} from "./_metronic/layout/core/default-layout.config";
import {LocaleService} from './i18n/service/locale.service';
import {I18N_AVAILABLE_VOCABS} from "../_config/languages";
import {ConnectionStatusService} from "./shared/services/connection-status.service";
import {CustomLoaderService} from "./shared/services/custom-loader.service";
import {NgxUiLoaderConfig, NgxUiLoaderModule} from "ngx-ui-loader";
import {RouterOutlet} from "@angular/router";


@Component({
  selector: 'body[root]',
  template: `
      <ngx-ui-loader
              [text]="loaderConfig().text || ''"
              [textColor]="loaderConfig().textColor || 'black'"
              [textPosition]="loaderConfig().textPosition || 'center-center'"
              [hasProgressBar]="true"
              overlayColor="transparent"
              [fgsSize]="0"
      ></ngx-ui-loader>
      <router-outlet></router-outlet>`,
  styles: [`
    :host {
      height: 100%;
      margin: 0;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgxUiLoaderModule,
    RouterOutlet
  ],
  standalone: true
})
export class AppComponent implements OnInit, OnDestroy {
  loaderConfig: Signal<NgxUiLoaderConfig>;
  private connectionStatusService: ConnectionStatusService = new ConnectionStatusService()

  constructor(
    private layoutService: LayoutService,
    private localeService: LocaleService,
    private customLoaderService: CustomLoaderService,
  ) {
    this.loaderConfig = this.customLoaderService.getConfig();
  }

  ngOnInit() {
    const layoutDefaultConfig: ILayout = DefaultLayoutConfig;
    layoutDefaultConfig.header.left = 'page-title'; //activar top page title | 'menu' activar top mega menu
    this.layoutService.setConfig(layoutDefaultConfig)

    // register translations
    this.localeService.loadLocalesTranslations(...I18N_AVAILABLE_VOCABS);
    // init locale
    this.localeService.initLocale();

    this.connectionStatusService.startListener();
  }

  ngOnDestroy() {
    this.connectionStatusService.stopListener();
    this.localeService.destroySubscription();
  }


}
